import { render, staticRenderFns } from "./DKLXList.vue?vue&type=template&id=662e4e8a&scoped=true"
import script from "./DKLXList.vue?vue&type=script&lang=js"
export * from "./DKLXList.vue?vue&type=script&lang=js"
import style0 from "./DKLXList.vue?vue&type=style&index=0&id=662e4e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e4e8a",
  null
  
)

export default component.exports